import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {faBullseye, faGlobe, faLink, faPen, faQuestionCircle} from '@fortawesome/pro-solid-svg-icons';
import {TestObjectOrigin} from '@webmate-web-core/shared/types/testmgmt';

@Component({
    selector: 'wm-testobject-type-icon',
    standalone: true,
    imports: [CommonModule, FontAwesomeModule],
    templateUrl: './testobject-type-icon.component.html',
    styleUrls: ['./testobject-type-icon.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestObjectTypeIconComponent {

    @Input() origin?: TestObjectOrigin;

    @Input() compact: boolean = false;

    get icon(): IconDefinition {
        switch (this.origin) {
            case 'manual':
                return faPen;
            case 'url_list':
                return faLink;
            case 'crawled':
                return faGlobe;
            case 'observation_target':
                return faBullseye;
            default:
                return faQuestionCircle;
        }
    }

    get originClass(): string {
        return `origin-${this.origin ?? 'unknown'}`;
    }
}
